import { v4 } from 'uuid';

import { RatesSearchParams } from '@/components/rates-and-prices-listing/rates-prices.types';

import type { BPID } from '@energy-retailer/schema';

export type PricingQueryKey = [
  string,
  {
    postcode?: string;
    planID?: string;
    searchParam?: RatesSearchParams;
  },
];

type RatesPricingError = {
  error: string;
};

export type PricingResponse = {
  items: BPID[];
  error?: string;
};

export const getPricing = async ({
  queryKey,
}): Promise<PricingResponse | undefined> => {
  const [_key, params] = queryKey as PricingQueryKey;
  const { postcode, planID, searchParam } = params;

  const searchURL =
    searchParam === RatesSearchParams.PlanID || postcode?.length === 0
      ? `/api/plan?planID=${planID}&docOnly=true`
      : `/api/plans?postcode=${postcode}`;

  try {
    const response: Response = await window.AwsWafIntegration.fetch(searchURL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-correlation-id': v4(),
        'x-session-id': window.sessionStorage.getItem('sessionId') ?? '',
      },
    });

    if (response.ok) {
      const data = (await response.json()) as BPID[];

      return {
        items: data,
      };
    }

    if (response.status === 404) {
      const data = (await response.json()) as RatesPricingError;
      return { items: [], error: data.error };
    }
  } catch (error) {
    throw new Error('Unexpected error');
  }

  return { items: [] };
};
